import { takeLatest, all } from 'redux-saga/effects';

import axios from "../utils/axios";
import { ADD_CHATBOX_EVENTS, ADD_PROCTORING_EVENTS } from '../constants/app';

function* addChatboxEvents(action) {
    const { data } = action;

    try {
        yield axios.post('/test/add-events', data);
    } catch (e) {
        console.log(e);
    }
}

function* addProctoringEvents(action) {
    const { data } = action;

    try {
        yield axios.post('/test/add-proctoring-events', data);
    } catch (e) {
        console.log(e);
    }
}

export default function* appSaga() {
    yield all([yield takeLatest(ADD_CHATBOX_EVENTS, addChatboxEvents)]);
    yield all([yield takeLatest(ADD_PROCTORING_EVENTS, addProctoringEvents)]);
}